/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingPageLineActivationInflowSourceFormQueryFragmentDoc } from './SettingPageLineActivationInflowSourceForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateUserRegistrationInflowSourceDefinitionInput = {
  inflowSourceName: string;
  matchAssignedStaffGUIDs?: Array<string | number> | null | undefined;
  useShortenedURL?: boolean | null | undefined;
};

export type UpdateUserRegistrationInflowSourceDefinitionInput = {
  guid: string | number;
  inflowSourceName: string;
  matchAssignedStaffGUIDs?: Array<string | number> | null | undefined;
  useShortenedURL?: boolean | null | undefined;
};

export type FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery = { userRegistrationInflowSourceDefinitions: Array<{ guid: string, inflowSourceName: string, inflowCount: number, url: string, matchAssigned: { staffs: Array<{ guid: string }> } }>, lineActivationProviderLiffAppConfig: { liffId: string } | null };

export type FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery = { staffsByPlanner: Array<{ guid: string, displayName: string }> };

export type FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables = Exact<{
  guid: string | number;
}>;


export type FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery = { userRegistrationInflowSourceDefinition: { guid: string, inflowSourceName: string, useShortenedURL: boolean, matchAssigned: { staffs: Array<{ guid: string }> } }, staffsByPlanner: Array<{ guid: string, displayName: string }> };

export type CreateInflowSourceDefinitionMutationVariables = Exact<{
  input: Types.CreateUserRegistrationInflowSourceDefinitionInput;
}>;


export type CreateInflowSourceDefinitionMutation = { createUserRegistrationInflowSourceDefinition: { guid: string } };

export type UpdateInflowSourceDefinitionMutationVariables = Exact<{
  input: Types.UpdateUserRegistrationInflowSourceDefinitionInput;
}>;


export type UpdateInflowSourceDefinitionMutation = { updateUserRegistrationInflowSourceDefinition: { guid: string } };


export const FetchSettingsPageLineActivationInflowSourceDefinitionViewDocument = gql`
    query FetchSettingsPageLineActivationInflowSourceDefinitionView {
  userRegistrationInflowSourceDefinitions {
    guid
    inflowSourceName
    inflowCount
    url
    matchAssigned {
      staffs {
        guid
      }
    }
  }
  lineActivationProviderLiffAppConfig {
    liffId
  }
}
    `;

/**
 * __useFetchSettingsPageLineActivationInflowSourceDefinitionViewQuery__
 *
 * To run a query within a Vue component, call `useFetchSettingsPageLineActivationInflowSourceDefinitionViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSettingsPageLineActivationInflowSourceDefinitionViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchSettingsPageLineActivationInflowSourceDefinitionViewQuery();
 */
export function useFetchSettingsPageLineActivationInflowSourceDefinitionViewQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>(FetchSettingsPageLineActivationInflowSourceDefinitionViewDocument, {}, options);
}
export function useFetchSettingsPageLineActivationInflowSourceDefinitionViewLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>(FetchSettingsPageLineActivationInflowSourceDefinitionViewDocument, {}, options);
}
export type FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchSettingsPageLineActivationInflowSourceDefinitionViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionViewQueryVariables>;
export const FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewDocument = gql`
    query FetchSettingsPageLineActivationInflowSourceDefinitionCreateView {
  ...SettingPageLineActivationInflowSourceFormQuery
}
    ${SettingPageLineActivationInflowSourceFormQueryFragmentDoc}`;

/**
 * __useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery__
 *
 * To run a query within a Vue component, call `useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery();
 */
export function useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>(FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewDocument, {}, options);
}
export function useFetchSettingsPageLineActivationInflowSourceDefinitionCreateViewLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>(FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewDocument, {}, options);
}
export type FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionCreateViewQueryVariables>;
export const FetchSettingsPageLineActivationInflowSourceDefinitionEditViewDocument = gql`
    query FetchSettingsPageLineActivationInflowSourceDefinitionEditView($guid: ID!) {
  userRegistrationInflowSourceDefinition(guid: $guid) {
    guid
    inflowSourceName
    useShortenedURL
    matchAssigned {
      staffs {
        guid
      }
    }
  }
  ...SettingPageLineActivationInflowSourceFormQuery
}
    ${SettingPageLineActivationInflowSourceFormQueryFragmentDoc}`;

/**
 * __useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery__
 *
 * To run a query within a Vue component, call `useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery(variables: FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables | VueCompositionApi.Ref<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables> | ReactiveFunction<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>(FetchSettingsPageLineActivationInflowSourceDefinitionEditViewDocument, variables, options);
}
export function useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewLazyQuery(variables?: FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables | VueCompositionApi.Ref<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables> | ReactiveFunction<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>(FetchSettingsPageLineActivationInflowSourceDefinitionEditViewDocument, variables, options);
}
export type FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery, FetchSettingsPageLineActivationInflowSourceDefinitionEditViewQueryVariables>;
export const CreateInflowSourceDefinitionDocument = gql`
    mutation CreateInflowSourceDefinition($input: CreateUserRegistrationInflowSourceDefinitionInput!) {
  createUserRegistrationInflowSourceDefinition(input: $input) {
    guid
  }
}
    `;

/**
 * __useCreateInflowSourceDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateInflowSourceDefinitionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateInflowSourceDefinitionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateInflowSourceDefinitionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateInflowSourceDefinitionMutation(options: VueApolloComposable.UseMutationOptions<CreateInflowSourceDefinitionMutation, CreateInflowSourceDefinitionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateInflowSourceDefinitionMutation, CreateInflowSourceDefinitionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateInflowSourceDefinitionMutation, CreateInflowSourceDefinitionMutationVariables>(CreateInflowSourceDefinitionDocument, options);
}
export type CreateInflowSourceDefinitionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateInflowSourceDefinitionMutation, CreateInflowSourceDefinitionMutationVariables>;
export const UpdateInflowSourceDefinitionDocument = gql`
    mutation UpdateInflowSourceDefinition($input: UpdateUserRegistrationInflowSourceDefinitionInput!) {
  updateUserRegistrationInflowSourceDefinition(input: $input) {
    guid
  }
}
    `;

/**
 * __useUpdateInflowSourceDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateInflowSourceDefinitionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInflowSourceDefinitionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateInflowSourceDefinitionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInflowSourceDefinitionMutation(options: VueApolloComposable.UseMutationOptions<UpdateInflowSourceDefinitionMutation, UpdateInflowSourceDefinitionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateInflowSourceDefinitionMutation, UpdateInflowSourceDefinitionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateInflowSourceDefinitionMutation, UpdateInflowSourceDefinitionMutationVariables>(UpdateInflowSourceDefinitionDocument, options);
}
export type UpdateInflowSourceDefinitionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateInflowSourceDefinitionMutation, UpdateInflowSourceDefinitionMutationVariables>;